/**
 * Error service class
 */
export default class ErrorService {
  /**
   * Errors holder for errors that will not be displayed on front
   * @type {Array}
   */
  static errors = [];
  /**
   * All native exception types
   * @type {Array}
   */
  static exceptions = {
    Error,
    ReferenceError,
    RangeError,
    SyntaxError,
    TypeError,
    URIError,
    EvalError,
  };

  /**
   * Create new Error
   * @param type
   * @param message
   * @param messageParam
   * @param store
   */
  static showError({ type = 'error', message = '', messageParam = '' }, store) {
    store.commit('setErrorMessage', {
      type,
      message,
      messageParam,
    });
  }

  /**
   * Log errors that we do not want to display
   * @param code
   * @param message
   * @param fileName
   * @param lineNumber
   * @param errString
   */
  static logError({ code = '', message = '', fileName = '', lineNumber = '' }, errString = '') {
    this.errors.push({
      code,
      message,
      fileName,
      lineNumber,
      errString,
    });
  }

  /**
   * Log hidden errors
   */
  static getHiddenErrors() {
    return this.errors;
  }
}
